import { render, staticRenderFns } from "./SendNotificationModal.vue?vue&type=template&id=421487c9&"
import script from "./SendNotificationModal.vue?vue&type=script&lang=ts&"
export * from "./SendNotificationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports